import { useEffect, useState } from "react";
import { OnboardingData, View } from "./types";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { getErrorMessage } from "utils/error";
import { toast } from "react-toastify";

export const useOnboardingController = () => {
  const [view, setView] = useState<View>(View.Default);
  const param = useParams();

  const onboardingMeta = useQuery<OnboardingData>({
    queryKey: ["ONBOARDING"],
    queryFn: () =>
      instance
        .get("/portal/v1/partners/onboarding")
        .then((res) => res.data)
        .catch((err) => {
          // Was in onError
          toast.error(getErrorMessage(err));
        }),
    refetchInterval: 4000
  });

  const viewChange = (view: View) => {
    // Add view to urlParams
    // TODO: This doesn't look right
    if (view === View.Default) window.history.pushState({}, "", `/`);
    else window.history.pushState({}, "", `?view=${view}`);
    setView(view);
  };

  useEffect(() => {
    switch (param.view) {
      case View.IDV:
        setView(View.IDV);
        break;
      case View.Billing:
        setView(View.Billing);
        break;

      case View.KYB:
        setView(View.KYB);
        break;
      default:
        setView(View.Default);
        break;
    }
  }, [param]);

  return {
    view,
    setView: viewChange,
    onboardingMeta
  };
};
